//var MessagesAPI = require('../api').Messages;

module.exports = function MessagesController($scope, $state, ngDialog) {
  var vm = this;


  vm.people = [
    {
      name: 'Karl Smith',
      organisation: 'The Smith Trust',
      img: 'https://placehold.co/45X45?text=profile+image'
    },
    {
      name: 'Jon HawkinsHawkins',
      organisation: 'Red River',
      img: 'https://placehold.co/45X45?text=profile+image'
    },
    {
      name: 'Jane Smith',
      organisation: 'The Smith Trust',
      img: 'https://placehold.co/45X45?text=profile+image'
    }
  ];


  vm.links = [
    {
      name: 'Scheme: Unicorn Trust',
    },
    {
      name: 'Application: 11232'
    }
  ];



  function init() {

  }

  init();
}
